<template>
  <div class="container">
    <crumb :prevLevel="prevLevel" current="供应商白名单" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="enterpriseType + '企业名称'">
              <el-input
                :placeholder="`请输入${enterpriseType}企业名称`"
                v-model="entName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商名称">
              <el-input placeholder="请输入供应商名称" v-model="supplierName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商省份" label-width="110px">
              <el-select placeholder="请选择供应商省份" v-model="provinceCode">
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.short_name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                style="margin-left:20px"
                @click="initQuery()"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">供应商数量统计</div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ entCount }}</div>
            <div class="text">{{ enterpriseType }}企业数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ supplierCount }}</div>
            <div class="text">供应商数量</div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" echartsHeight="380px" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">供应商列表</div>
      <el-table :data="supplierList">
        <el-table-column prop="compName" :label="enterpriseType + '企业名称'" />
        <el-table-column prop="orgCode" label="供应商统一社会信用代码" />
        <el-table-column prop="supplierName" label="供应商名称" />
        <el-table-column prop="shortName" label="供应商所属省份" />
        <el-table-column prop="supplierAddress" label="供应商地址" />
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadSupplierList"
        :page-size="5"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import enterpriseTypeMixin from './enterprise-type.mixin';

export default {
  data() {
    return {
      entType: '',
      supplierName: '',
      provinceCode: '',
      entName: '',
      entCount: 0,
      supplierCount: 0,
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '10px',
          left: '3%',
          right: '4%',
          bottom: '20px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            minInterval: 1
          }
        ],
        series: [
          {
            name: '供应商数量',
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            },
            data: []
          }
        ]
      },
      supplierList: [],
      total: 0,
      currentPage: 1
    };
  },
  computed: {
    ...mapState(['provinceList'])
  },
  mounted() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      if (this.enterpriseType === '生产') {
        this.entType = this.$common.entType.production;
      } else {
        this.entType = this.$common.entType.circulate;
      }
      this.loadChartsData();
      this.loadSupplierList(1);
    },
    loadChartsData() {
      this.$request({
        url: 'rest/circulation/supplierDetailStatics',
        data: {
          json: JSON.stringify({
            params: {
              entName: this.entName,
              entType: this.entType,
              superviseName: this.supplierName,
              provinceCode: this.provinceCode
            }
          })
        }
      }).then(res => {
        this.entCount = res.entNum;
        this.supplierCount = res.supplierNum;
        const list = res.list;
        const xData = [];
        const yData = [];
        list.forEach(item => {
          xData.push(item.organ_name);
          yData.push(item.supplier_num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    loadSupplierList(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'rest/circulation/supplierDetailList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              entName: this.entName,
              entType: this.entType,
              superviseName: this.supplierName,
              provinceCode: this.provinceCode
            }
          })
        }
      }).then(res => {
        this.supplierList = res ? res.list : [];
        this.total = res ? res.total : 0;
      });
    }
  },
  mixins: [enterpriseTypeMixin],
  components: {
    Echarts,
    Crumb
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
</style>
